import { css } from '@emotion/core'

export const minWidthCss = css`
  /* To prevent child content from stretching the grid between columns. */
  min-width: 0;
`

// Using 16px because Checkbox has -12px margin; so this gives 4px space around the checkbox
export const MARGIN_X_DEFAULT = 16
export const MARGIN_Y_DEFAULT = 12
